import styled from 'styled-components';

export const Container = styled.div<any>`
  display: 'block';
  width: '100%';
  height: '1px';
  background-color: '#F7F7F7';
`;
